module.exports = __webpack_public_path__ + "static/media/4.33e4aef8.jpg";